import { SET_IS_BEING_DRAGGED } from '../actions/types';

export default function isBeingDragged(state = false, action) {
	switch (action.type) {
		case SET_IS_BEING_DRAGGED: {
			return action.payload;
		}
		// no default
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/isBeingDragged.js